export default __webpack_public_path__ + "static/media/Communication.f8cdb999.svg";